import './lib/env';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { FlagProvider } from '@unleash/proxy-client-react';
import { App } from './App';
import { queryClient, idbPersister } from './lib/queryClient';
import { unleashClient } from './lib/flags';
import { lightTheme, darkTheme, useResolvedMode } from './theme';
import { ConsentProvider } from './lib/ConsentProvider';
import { ConsentBanner } from './components/ConsentBanner/ConsentBanner';

function Root() {
  const resolvedMode = useResolvedMode();
  const theme = resolvedMode === 'dark' ? darkTheme : lightTheme;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ConsentProvider>
      <ConsentBanner />
      <PersistQueryClientProvider client={queryClient} persistOptions={{ persister: idbPersister }}>
        <FlagProvider unleashClient={unleashClient} startClient={false}>
          <Root />
        </FlagProvider>
      </PersistQueryClientProvider>
    </ConsentProvider>
  </StrictMode>,
);
